import React, { useState } from 'react'
import { UilSearch, UilLocationPoint } from "@iconscout/react-unicons"

export default function Inputs({ setQuery }) {
  const [city, setCity] = useState("")

  const handleSearchClick = () => {
    if(city !== "") setQuery({q: city, units:'metric'})
  }

  return (
    <div className='justify-center  w-full '>
      <div className='flex flex-wrap sm:w-full lg:w-full items-center justify-center space-x-4 '>

        <input type="text" className='rounded-md text-xl font-light p-2 sm:w-64 lg:w-2/5 shadow-xl focus:outline-none capitalize placeholder:lowercase' 
                placeholder='Search for city' 
                value={city}
                onChange={(e)=>setCity(e.currentTarget.value)}
                />
        <UilSearch size={25} className='text-white cursor-pointer'
                    onClick={handleSearchClick}
        />
      </div>
    </div>
  )
}
